export const ProjectData = [
    {
        id: 1,
        title: 'Bingo I',
        catogory: 'BINGO',
        model: 'CUSTOMIZE',
        image: "assets/bingoBackground.jpeg",
    },
    {
        id: 2,
        title: 'Bingo II',
        catogory: 'BINGO',
        model: 'HANZI 500',
        image: "assets/bingoBackground.jpeg",
    },
    {
        id: 3,
        title: 'Flashcard I',
        catogory: 'FLASHCARD',
        model: 'CUSTOMIZE',
        image: "assets/flashcardBackground.jpg",
    },
    {
        id: 4,
        title: 'Flashcard II',
        catogory: 'FLASHCARD',
        model: 'HANZI 500',
        image: "assets/flashcardBackground.jpg",
    },
    {
        id: 5,
        title: 'Word Search I',
        catogory: 'WORD SEARCH',
        model: 'CUSTOMIZE',
        image: "assets/wordSearchBackground.webp",
    }
    
]